import React from 'react';
import "./styles.css";

const PageHeader = () => {
  return (
    <header className="page-header">
      <div className="top-bar-header">
        <h1>MentorHouse</h1>
      </div>
    </header>

  );
}

export default PageHeader;